<template>
   <router-link :to="link" class="novelListItem" :id="id" :style="{'background-image': 'url(' + this.novelData['imageURL'] + ')'}">
    <div class="filter-brightness">
      <h3 v-html="title"></h3>
      <h4 v-html="author"></h4>
    </div>
  </router-link>
</template>

<script>
export default {
  name: 'NovelListItem',
   props: ["novelData"],
  computed:{
    title: function(){
      return this.novelData.title;
    },
    link: function(){
      return '/novel/' + this.novelData.id;
    },
    author: function(){
      return this.novelData.author; 
    },
    id : function(){
      return this.novelData.id;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.novelListItem{
  height: 50vw;
  width: 90vw;
  margin: 15px 0;
  padding:0;
  box-shadow: 0 0 2px 2px black;
  border-radius: 5px;
  box-shadow: 3px 3px 2px black;
  background-position: 50% 50%;
  background-size: 110% auto;
  background-repeat:  no-repeat;
  display:block;
  text-decoration: none;
}

.filter-brightness{
  width:100%;
  height:100%;
  margin:0;
  background: rgba(0,0,0,0.8);
  text-align: center;
  display: block;
  position: relative;
  
}

.novelListItem div h3{
  text-decoration: none;
  position: absolute;
  display: block;
  top: 40%;
  left: 50%;
  margin: 0;
  margin-right: -50%;
  transform: translate(-50%,-50%);
  width: 100%;
  vertical-align:middle;
  font-size: 2.25em;
  color: white;
  text-stroke:1px black;
  -webkit-text-stroke: 1px black;
  text-shadow: 0 2px 2px #666;
}

.novelListItem div h4{
  text-decoration: none;
  display: block;
  position: absolute;
  top: 85%;
  left: 50%;
  margin: 0;
  margin-right: -50%;
  transform: translate(-50%,-50%);
  width: 100%;
  width: 100%;
  vertical-align:middle;
  font-size: 2.0em;
  color: white;
  text-stroke:1px black;
  -webkit-text-stroke: 1px black;
  text-shadow: 0 2px 2px #666;
}

@media screen and (min-width: 1280px){
.novelListItem{
  height: 315px;
  width: 560px;
  margin: 15px 0;
  padding:0;
  box-shadow: 0 0 2px 2px black;
  border-radius: 5px;
  box-shadow: 3px 3px 2px black;
  background-position: 50% 50%;
  background-size: 110% auto;
  background-repeat:  no-repeat;
  display:block;
  text-decoration: none;
}

.novelListItem div h3{
  text-decoration: none;
  position: absolute;
  display: block;
  top: 40%;
  left: 50%;
  margin: 0;
  margin-right: -50%;
  transform: translate(-50%,-50%);
  width: 100%;
  vertical-align:middle;
  font-size: 50px;
  color: white;
  text-stroke:1px black;
  -webkit-text-stroke: 1px black;
  text-shadow: 0 2px 2px #666;
}

.novelListItem div h4{
  text-decoration: none;
  display: block;
  position: absolute;
  top: 80%;
  left: 50%;
  margin: 0;
  margin-right: -50%;
  transform: translate(-50%,-50%);
  width: 100%;
  width: 100%;
  vertical-align:middle;
  font-size: 40px;
  color: white;
  text-stroke:1px black;
  -webkit-text-stroke: 1px black;
  text-shadow: 0 2px 2px #666;
}
}
</style>
